export const HELP_CENTER_URL = 'https://help.bilderit.com';
